// @ts-strict-ignore
import type { MutationClass } from '../../../models'

export class ResetMutation implements MutationClass {
  static execute(this: void, state, initialState): void {
    Object.assign(state, initialState)
  }
}
